import axios from 'axios';
import { redirectToLogin } from '@/services/authRedirect'
import router from '../router/router'

export default class CheckPermission {
    async updatePermission(isSelect = false) {
        // await AccountRepository.get()
        return new Promise((resolve, reject) => {
            axios.get('/userinfo')
            .then(_response => { 
                // console.log('response', _response)
                const response = _response.data
                localStorage.tenantId = response.tenant_id
                window.userName = response.name
                window.preferred_username = response.preferred_username
                const arrayOfPermission = [
                    ...(response.userGroupPermissions || []),
                    ...(response.permission_role || [])
                ]
                localStorage.setItem('permission', arrayOfPermission);
                resolve(arrayOfPermission);
                // resolve(response)
            })
            .catch(error => {
                if (error && error.response.status === 401) {
                    redirectToLogin(router)
                }
            });
        })
       
    }

    isCanAccess(permissionName) {
        var params = [];
        if (permissionName instanceof Array) params = permissionName;
        else params = [permissionName];
        var arrayPermission = localStorage.getItem('permission').split(',');
        var result = _.intersection(arrayPermission, params).length > 0;
        if(!result && process.env.VUE_APP_DEVELOPMENT == 'development') console.log(permissionName)
        return result
    }
}
